import { render, staticRenderFns } from "./POD.vue?vue&type=template&id=6946ad4a&scoped=true"
import script from "./POD.vue?vue&type=script&lang=ts"
export * from "./POD.vue?vue&type=script&lang=ts"
import style0 from "./POD.scss?vue&type=style&index=0&id=6946ad4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946ad4a",
  null
  
)

export default component.exports